import {FC} from "react";
import {Modal, Spin} from "antd";
import {VacancyModalProps} from "../../types";
import VacancyForm from "./components/vacancy-form/VacancyForm";

const VacancyModal: FC<VacancyModalProps> = (props) => {
  const {vacancyController} = props
  const {isCreateModalOpen, form, toggleCreateModalOpen, selectedVacancy, isLoading} = vacancyController


  const okButtonHandler = () => {
    form.submit()
  }

  const title = selectedVacancy ? "Редагувати вакансію" : "Додати вакансію"

  return <Modal destroyOnClose title={title} open={isCreateModalOpen} onCancel={toggleCreateModalOpen}
                okText="Зберегти"
                cancelText="Cкасувати"
                onOk={okButtonHandler}>
    <Spin spinning={isLoading}>
      <VacancyForm vacancyController={vacancyController}/>
    </Spin>
  </Modal>
}

export default VacancyModal
